import { PathsElement } from '@swagger-api/apidom-ns-openapi-3-0';
class Paths extends PathsElement {}
export default Paths;